import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: 0;
  `}
`;

export const InputsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
  padding: 0;
  & svg {
    flex-shrink: 0;
    align-self: baseline;
  }
`;

export const Inputs = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  & .textfield-input {
    border-radius: 30px;
  }
  & .autocomplete-suggestions {
    position: relative;
    width: calc(100% + 50px);
    right: auto;
    left: calc(0px + 50px);
    border: 0 none;
    box-shadow: none;
    margin-top: 40px;
    &::before {
      content: "חיפושים אחרונים";
      color: #303030;
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 16px;
      display: block;
    }
  }
`;

export const LikeInput = styled.div`
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 100px;
  border: 0 solid #303030;
  background: #F3F3F3;
  text-align: right;
`;

export const MoreResultsWrapper = styled.div`
  max-height: 464px;
  overflow: auto;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    max-height: none;
  `}
`;

export const SuggestedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const SuggestedListItemWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: ${({ theme }) => theme.spacing(2)};
  &:hover {
    background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  }
`;

export const Info = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &:hover {
    background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  }
`;

export const IconWrapper = styled.div<{ skipWrapper?: boolean }>`
  ${({ theme, skipWrapper }) => skipWrapper ? '' : `
    width: 48px;
    height: 48px;
    background-color: ${theme.colors.neutrals.grey10};
    border-radius: ${theme.borderRadius.small};
    div:hover > & {
      background-color: ${theme.colors.neutrals.white};
    }
  `}
  display: flex;
  align-items: center;
  justify-content: center;
`;
